import { IListObjectStore } from "../../_common/type";
import { IJobHOCState } from "../../_core/job/types";
import { EMARPOLDocuments } from "../marpol/@types";
import { CLEANING_CHEMICALS } from "./groups/cleaning-chemicals";
import { REFRIGERANTS } from "./groups/refrigerants";
import { PACKAGING } from "./groups/packaging";
import { EMISSIONS } from "./groups/emissions";

export enum EEMFOperationState {
	RECORD = "RECORD",
	PREVIEW = "PREVIEW",
}

export enum EEMFRecordState {
	APPROVED = "APPROVED",
	STRIKED_OFF = "STRIKED-OFF",
	SUBMITTED = "SUBMITTED",
	IDLE = "IDLE",
	EDIT = "EDIT",
	VERIFIED = "VERIFIED",
}

export enum EEMFRecordCode {
	PACKAGING = "PACKAGING",
	REFRIGERANTS = "REFRIGERANTS",
	CLEANING_CHEMICALS = "CLEANING_CHEMICALS",
	VOC_NMVOC = "VOC_NMVOC",
}

export type TEMFRecordUser = {
	name: string;
	designation: string;
	staffId: string;
	date: string;
};

export type TEMFCommonFields = {
	selectedDate: string;
	remarks: string;
};

export type TEMFRecord =
	| CLEANING_CHEMICALS
	| EMISSIONS
	| PACKAGING
	| REFRIGERANTS;

export type TEMFCommonData = {
	id: string;
	/**
	 * @description It's an ID for latest update for a document with given id.
	 */
	_rev: string;
	marpolType: EMARPOLDocuments.EMF;
	state: EEMFRecordState;
	submittedBy?: TEMFRecordUser;
	approvedBy?: TEMFRecordUser;
	verifiedBy?: TEMFRecordUser;
	strikedBy?: TEMFRecordUser;
	strikeOffReason?: string;
	editVersions?: TEMFBackendRecord[];
	dateOfApprovedRecordEdit?: string;
	_attachments?: object;
};

export interface TEmfCategoryRecord {
	_id: string;
	count: number;
}

export type TEMFUsageData = {
	_id: string;
	imoNumber: string;
	vesselName: string;
	emfRecordCount: number;
	emfRecords: TEmfCategoryRecord[];
};

export type TEMFBackendRecord = TEMFRecord & {
	submittedBy: TEMFRecordUser;
	approvedBy?: TEMFRecordUser;
	verifiedBy?: TEMFRecordUser;
	strikedBy?: TEMFRecordUser;
	editedBy?: TEMFRecordUser;
};

export type TEMFCurrentOperation = {
	recordCode: EEMFRecordCode;
	operationState: EEMFOperationState;
	formData: TEMFRecord;
	validationAlerts: IListObjectStore<TEMFCurrentOperationAlert>;
	editMode?: EEMFEditMode;
};

export enum EEMFEditMode {
	GENERAL = "GENERAL",
	APPROVED_EDIT = "APPROVED_EDIT",
}

export type TEMFCurrentOperationAlert = {
	id: string;
	type:
		| "WARNING"
		| "ERROR"
		| "INFO"
		| "REQUIRED_FIELD"
		| "OBSERVED_QUANTITY_ALERT";
	title: string;
	subtitle: string;
	message: string;
	listOfItems?: {
		title: string;
		subtitle?: string;
		message?: string;
		link?: string;
	}[];
	action?: {
		title: string;
		link: string;
	};
};

export type TEMFHistoryFilters = {
	startDate: any;
	endDate: any;
	shownRecords: "ALL" | "ALL-PENDING";
	type: EEMFRecordCode | string;
	state?: EEMFRecordState | string;
	sortOrder?: "asc" | "desc";
};

export interface IEMFStore extends IJobHOCState {
	records: IListObjectStore<TEMFBackendRecord>;
	currentOperation?: TEMFCurrentOperation;
	filter: TEMFHistoryFilters;
}
